import Vue from 'vue'
import '@/plugins'

import store from './store'
import router from './router'

import App from './App'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {ClientTable} from 'vue-tables-2';
import 'vue-js-modal/dist/styles.css'

library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(ClientTable, {}, false, 'bootstrap4')
Vue.config.productionTip = false
import '@/components'

// sync(store, router);
var vm = new Vue({
  router,
  store,
  ...App,
  el: '#app',
})


// WEBPACK FOOTER //
// ./src/main.js